import { render, staticRenderFns } from "./rightB-temp3.vue?vue&type=template&id=c5dcc0b2&scoped=true"
import script from "./rightB-temp3.vue?vue&type=script&lang=js"
export * from "./rightB-temp3.vue?vue&type=script&lang=js"
import style0 from "./rightB-temp3.vue?vue&type=style&index=0&id=c5dcc0b2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5dcc0b2",
  null
  
)

export default component.exports